var map = {
	"./company-honor-COC-20230510.jpg": "9b06",
	"./company-honor-COC-20230718.jpg": "d2fb",
	"./company-honor-MHRA-20231219.jpg": "d5a1",
	"./company-honor-MHRA-20240411.jpg": "24f0",
	"./company-honor-MHRA-20241028.jpg": "70ae",
	"./company-honor-RoHS-20240408.jpg": "c8fb",
	"./company-honor-RoHS-20240531.jpg": "7598",
	"./company-honor-RoHS-20241023.jpg": "ee9e",
	"./company-honor-RoHS-20241212.jpg": "3366",
	"./company-honor-TPD-20230721.jpg": "2768",
	"./company-honor-TPD-20231219.jpg": "dc37",
	"./company-honor-TPD-20240411.jpg": "6e04",
	"./company-honor-TPD-20241028.jpg": "fc81",
	"./company-honor-VOC-20230309.jpg": "a985",
	"./company-honor-VOC-20241024.jpg": "8605",
	"./company-honor-VOC-20241218.jpg": "fd63"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "218e";